// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"3124":"609732c5","7803":"a01817cb","8847":"7b672fd0"}[chunkId] + ".css";
};